import { useState } from "react";
import { CssBaseline } from "@mui/material";
import { Toaster } from "react-hot-toast";
import { AuthProvider } from "@context/shared/AuthContext";
import { ThemeProvider } from "@context/shared/ThemeContext";
import { SessionEffects } from "@components/shared/session-effects";
import { KonamiModal } from "@components/client/elements/konami-modal";
import useKonamiCode from "@hooks/client/use-konami-code";
import AppRoutes from "./routes";

/**
 * Main App component
 *
 * Note: No <BrowserRouter> wrapper here!
 * Router is created in main.jsx using createBrowserRouter()
 * This is required for useBlocker() in FormDirtyContext
 */

function App() {
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  useKonamiCode({ handleOpen });

  return (
    <>
      <ThemeProvider>
        <CssBaseline />
        <AuthProvider>
          <AppRoutes />
          <Toaster
            position="bottom-left"
            toastOptions={{
              duration: 4000,
              style: {
                background: "#363636",
                color: "#fff",
              },
              success: {
                duration: 3000,
                iconTheme: {
                  primary: "#4caf50",
                  secondary: "#fff",
                },
              },
              error: {
                duration: 5000,
                iconTheme: {
                  primary: "#f44336",
                  secondary: "#fff",
                },
              },
            }}
          />
          <SessionEffects />
        </AuthProvider>
      </ThemeProvider>
      <KonamiModal onClose={handleClose} open={open} />
    </>
  );
}

export default App;
